import {Button} from 'antd';
import React from 'react';

import type {PackagingChecklist} from '../../../services/interface/pcfTypes';
import type {PcfSelectOption} from '../constants/pcfOptions';

interface ChoiceChipsProps {
  options: PcfSelectOption[];
  values: PackagingChecklist | Record<string, boolean>;
  onToggle: (value: string) => void;
}

const ChoiceChips: React.FC<ChoiceChipsProps> = ({
  options,
  values,
  onToggle
}) => {
  return (
    <div className="choice-chips">
      {options.map((opt) => {
        const checked = Boolean(
          (values as Record<string, boolean | undefined>)[opt.value]
        );

        return (
          <Button
            key={opt.value}
            htmlType="button"
            aria-pressed={checked}
            className={`choice-chip ${checked ? 'checked' : ''}`}
            onClick={() => {
              onToggle(opt.value);
            }}
          >
            <span className={`choice-chip-box ${checked ? 'checked' : ''}`}>
              {checked && (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12L10 17L20 7"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
            <span className="choice-chip-label">{opt.label}</span>
          </Button>
        );
      })}
    </div>
  );
};
export default ChoiceChips;
